import { useFeatureOffersQuery, useSortedOffersQuery } from 'generated/sanity-graphql';
import { useCustomizableContent } from 'state/customizable-content';
import { useFeaturesContext } from 'state/features';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

// This hook works for choosing sortedOffers set during AppData migration
export const useOffersDataset = () => {
  const enableHomePageAppDataMigration = useFlag(
    LaunchDarklyFlag.ENABLE_HOME_PAGE_APP_DATA_MIGRATION
  );
  const enableQueryOffersFromBackend = useFlag(LaunchDarklyFlag.ENABLE_QUERY_OFFERS_FROM_BACKEND);

  // query for featureOffersResponse
  const { featureOffersId, featureIdsLoading } = useFeaturesContext();
  // wait to fetch featureOffers until featureOffersId exists
  const featureOffersIdExist = !featureIdsLoading && featureOffersId;
  const skipQuery = !featureOffersIdExist;
  const featureOffersIdVar = featureOffersIdExist ? featureOffersId : '';
  const featureOffersResponse = useFeatureOffersQuery({
    variables: { featureOffersId: featureOffersIdVar ?? '' },
    skip: skipQuery || !enableHomePageAppDataMigration || enableQueryOffersFromBackend
  });

  // query for sortedOffersResponse
  const { appDataId } = useCustomizableContent();
  const sortedOffersResponse = useSortedOffersQuery({
    variables: { appDataId },
    skip: !appDataId || enableHomePageAppDataMigration || enableQueryOffersFromBackend
  });

  if (enableQueryOffersFromBackend) {
    return {
      data: { sortedOffers: [] },
      loading: false,
      refetch: () => Promise.resolve()
    };
  }

  if (enableHomePageAppDataMigration) {
    return {
      data: featureOffersResponse.data?.FeatureOffers,
      loading: featureOffersResponse.loading,
      refetch: featureOffersResponse.refetch
    };
  }
  return {
    data: sortedOffersResponse.data?.AppData,
    loading: sortedOffersResponse.loading,
    refetch: sortedOffersResponse.refetch
  };
};
